export const hasRevenueForMarginPercent = (revenue: number | null | undefined): boolean => (
  Number(revenue || 0) > 0
);
